import { useCssVariableBreakpoint } from '@cdab/scania/qpr/hooks'
import { Outlet } from 'react-router'
import { cssTransition } from 'react-toastify'
import { StyledToastContainer } from './toast-container.styles'
import './toast.css'

const tdsSlide = cssTransition({
  enter: 'slideInUp',
  exit: 'slideOutRight'
})

export const ToastContainer = () => {
  const isLg = useCssVariableBreakpoint('--tds-grid-lg')

  return (
    <>
      <StyledToastContainer
        hideProgressBar
        limit={isLg ? 2 : 1}
        closeButton={false}
        autoClose={5000}
        transition={tdsSlide}
        position='bottom-right'
      />
      <Outlet />
    </>
  )
}
